module.exports = __webpack_public_path__ + "bb68ac088629b6788e361a861aadaf6a.svg";